const clubsModule = {
    actions: {
        setType: 'clubs/actions/setType',
        initFilter: 'clubs/actions/initFilter',
        resetPagination: 'clubs/actions/resetPagination',
        filter: {
          set: 'clubs/actions/filter/set'
        },
        clubs: {
            submit: 'clubs/actions/clubs/submit',
            remove: 'clubs/actions/clubs/remove',
            cleanUp: 'clubs/actions/clubs/cleanUp',
            update: 'clubs/actions/clubs/update',
            updateMembers: 'clubs/actions/clubs/updateMembers',
            updateInvitedMembers: 'clubs/actions/clubs/updateInvitedMembers',
            load: 'clubs/actions/clubs/load',
            loadMore: 'clubs/actions/clubs/loadMore',
            loadInfo: 'clubs/actions/clubs/loadInfo',
            report: 'clubs/actions/clubs/report',
            like: 'clubs/actions/clubs/like',
            loadMembers: 'clubs/actions/clubs/loadMembers'
        },
        membership: {
            set: 'clubs/actions/membership/set',
            setMy: 'clubs/actions/membership/setMy',
            add: 'clubs/actions/membership/add',
            addMy: 'clubs/actions/membership/addMy',
            remove: 'clubs/actions/membership/remove',
            removeMy: 'clubs/actions/membership/removeMy',

            request: 'clubs/actions/membership/request',
            update: 'clubs/actions/membership/update',

            subscribe: 'clubs/actions/membership/subscribe',
            unsubscribe: 'clubs/actions/membership/unsubscribe',
            unsubscribeFromAll: 'clubs/actions/membership/unsubscribeFromAll',
        },
        setClub: 'clubs/actions/setClub',
    },
    mutations: {
        setType: 'clubs/mutations/setType',
        resetPagination: 'clubs/mutations/resetPagination',
        setLoading: 'clubs/mutations/setLoading',
        filter: {
            set: 'clubs/actions/filter/set'
        },
        setTransitionEnabled : 'events/mutations/setTransitionEnabled',
        clubs: {
            update: 'clubs/mutations/clubs/update',
            add: 'clubs/mutations/clubs/add',
            set: 'clubs/mutations/clubs/set',
            remove: 'clubs/mutations/clubs/remove',
            insert: 'clubs/mutations/clubs/insert',
            setPageNum: 'clubs/mutations/clubs/setPageNum',
            setPageMembersNum : 'clubs/mutations/clubs/setPageMembersNum',
        },
        membership: {
            add: 'clubs/mutations/membership/add',
            remove: 'clubs/mutations/membership/remove',
            addMy: 'clubs/mutations/membership/addMy',
            removeMy: 'clubs/mutations/membership/removeMy',
        },
        setBang: 'clubs/mutations/setBang',
        setClub: 'clubs/mutations/setClub',
        setLikes: 'clubs/mutations/setLikes',
    },
    getters: {
        type: 'clubs/getters/type',
        clubDates: 'clubs/getters/clubDates',
        clubIdsByDate: 'clubs/getters/clubIdsByDate',
        membershipClubsRequests: 'clubs/getters/membershipClubsRequests',
        hasMembershipClubsRequests: 'clubs/getters/hasMembershipClubsRequests',
        club: 'clubs/getters/club',
        clubTransitionEnabled: 'events/getters/clubTransitionEnabled',
    }
}

export default clubsModule
